import React from 'react';
import { debounce, has, isArray } from 'lodash';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import {
  LineChart,
  BarChart,
  PieChart,
} from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  AxisPointerComponent,
  TitleComponent,
  LegendComponent,
  DataZoomComponent,
  DataZoomSliderComponent,
  DatasetComponent,
} from 'echarts/components';
import {
  SVGRenderer,
} from 'echarts/renderers';
import { getDataZoomOptions } from './helpers/zoom';

import './styles.css';

echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, LegendComponent, AxisPointerComponent, DatasetComponent, DataZoomComponent, DataZoomSliderComponent, LineChart, BarChart, PieChart, SVGRenderer],
);

function EchartWrapper(props) {
  const { showLoading, option, loadingOption } = props;
  const zoomOptions = React.useRef({ start: 0, end: 100 });

  const onDataZoomChange = debounce((event) => {
    if (has(event, 'batch') && isArray(event.batch)) {
      const { start, end } = event.batch[0];

      zoomOptions.current.start = start;
      zoomOptions.current.end = end;
    } else {
      const { start, end } = event;

      zoomOptions.current.start = start;
      zoomOptions.current.end = end;
    }
  }, 500);

  option.baseOption.dataZoom = getDataZoomOptions(zoomOptions.current);

  // Register the required components
  return (
    <ReactEChartsCore
      echarts={echarts}
      notMerge
      lazyUpdate
      showLoading={showLoading}
      loadingOption={loadingOption}
      style={{ height: '100%', position: 'relative' }}
      option={option}
      onEvents={{ dataZoom: onDataZoomChange }}
      opts={{ renderer: 'svg' }}
    />
  );
}

EchartWrapper.defaultProps = {
  showLoading: false,
  option: {
    baseOption: {},
  },
  loadingOption: {},
};

export default EchartWrapper;
